import script from "./JaMaterialDelete.vue?vue&type=script&setup=true&lang=js"
export * from "./JaMaterialDelete.vue?vue&type=script&setup=true&lang=js"

import "./JaMaterialDelete.vue?vue&type=style&index=0&id=dcfcf13e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dcfcf13e"]])

export default __exports__